import { CircularProgress } from '@mui/material';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../../ReactComponent';

class Ementa extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            maxHeight: computed,
            minHeight: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get maxHeight() {
        return this.observableProps.maxHeight;
    }

    get minHeight() {
        return this.observableProps.minHeight;
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    maxHeight: this.maxHeight,
                    minHeight: this.minHeight,
                    fontFamily: 'sans-serif'
                }}
            >
                {!this.registro.ementa && this.appStore.requisicoesPendentes ? (
                    <CircularProgress
                        style={{ margin: '10px' }}
                        disableShrink={true}
                    />
                ) : (
                    <span
                        data-sentry-mask
                        style={{ color: 'black' }}
                        dangerouslySetInnerHTML={{ __html: this.registro.ementa }}
                    ></span>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(Ementa));
